
export type ProductTag = {
	id: string;
	name: string;
};

export type Ingredient = {
	id: string;
	name: string;
};

export interface FormattedProduct {
	id: string;
	name: string;
	brand: string;
	description: string;
	price: number;
	image: string;
	category: string;
	categoryId: string | null;
	tags: string[]; // Changed from ProductTag[] to string[] for compatibility with ProductCardProps
	supplierId: string;
	msrp?: number;
	caseQuantity?: number;
	shippingCost?: number;
	minOrder?: number;
	sampleAvailable?: boolean;
	sampleQuantity?: number;
	sampleCost?: number;
	totalViews?: number;
	totalQuantitySold?: number;
	isTestSupplier?: boolean;
}

export type CartItem = {
	id: string;
	name: string;
	price: number;
	quantity: number;
	caseQuantity?: number;
	image?: string;
	supplierId: string;
	supplierName?: string;
	shippingCost?: number;
	minOrderAmount?: number;
	minFreeShipping?: number;
};

// Helper function to transform Supabase Storage URLs to use the Image CDN for thumbnail generation
export const getOptimizedImageUrl = (
	url: string,
	width: number = 200,
	quality: number = 60
): string => {
	// Only process URLs that are from Supabase Storage
	if (
		!url ||
		!url.includes("supabase.co") ||
		url.includes("/placeholder.svg")
	) {
		return url;
	}

	// Check if the URL already has transformation parameters
	if (url.includes("width=") || url.includes("quality=")) {
		return url;
	}

	// Add the transformation parameters to the URL
	const separator = url.includes("?") ? "&" : "?";
	return `${url}${separator}width=${width}&quality=${quality}`;
};
